
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LoggedOutSidebar',
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    openModal(): void {
      this.isOpen = true
    },
    closeModal(): void {
      this.isOpen = false
    }
  },
  watch: {
    isOpen(newIsOpen: boolean) {
      if (newIsOpen && process.client) {
        document.body.classList.add('no-scroll')
      } else if (process.client) {
        document.body.classList.remove('no-scroll')
      }
    }
  }
})
